import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ApiErrorComponent, SelectableTileComponent } from '@comparit/core';
import { combineLatest, map, switchMap } from 'rxjs';
import type { ResponseStateHandler } from '../interfaces/response-state-handler.type';
import type { SchutzOptimierenForm } from './schutz-optimieren-form.class';

/**
 * The "Schutz optimieren" tile grid of a Sach funnel. Renders the catalogue's Kacheln against the
 * form; the step that hosts it owns the headline and the fetch.
 */
@Component({
  selector: 'ui-schutz-optimieren',
  imports: [MatProgressSpinner, ApiErrorComponent, SelectableTileComponent],
  templateUrl: './schutz-optimieren.component.html',
  styleUrl: './schutz-optimieren.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchutzOptimierenComponent {
  form = input.required<SchutzOptimierenForm<string>>();
  state = input.required<ResponseStateHandler<unknown>['state']>();

  retry = output<void>();

  protected tiles = toSignal(
    toObservable(this.form).pipe(
      switchMap(form =>
        combineLatest([form.kacheln$, form.fgValue$]).pipe(
          map(([kacheln]) =>
            kacheln.map(kachel => ({ kachel, selected: form.isKachelSelected(kachel) }))
          )
        )
      )
    ),
    { initialValue: [] }
  );
}
